// fileValidator.js
import { toast } from "react-toastify";
import EXIF from "exif-js";

const maliciousPatterns = [
  /eval\s*\(/i,
  /new\s+Function\s*\(/i,
  /setTimeout\s*\(/i,
  /setInterval\s*\(/i,
  /document\.write\s*\(/i,
  /<script>/i,
  /objShell/i,
  /.shell/i,
  /.wscript/i,
  /window\.location\s*=/i,
  /document\.cookie/i,
  /onerror\s*=/i,
  /src\s*=\s*["']javascript:/i,
  /Set\s+objShell\s*=\s*CreateObject\("WScript\.Shell"\)/i,
  /objShell\.Run\s*\("cmd\.exe\s*\/c\s*calc\.exe"/i
];
const dangerousRegex = /(?:<\s*script\b[^>]*>|<\/\s*script\s*>|\beval\b\s*\(|\bbase64\b|document\.cookie|window\.location|\balert\b\s*\(|\bonerror\b|<\s*iframe\b[^>]*>|javascript:|\bcmd\b|\bpowershell\b|\bexec\b\s*\(|unescape\s*\(|innerHTML)/i;

const extractImageMetadata = (file) =>
  new Promise((resolve) => {
    EXIF.getData(file, function () {
      resolve(EXIF.getAllTags(this) || {});
    });
  });

const validateMetadataContent = (metadata = {}) => {
  const comment = metadata.Comment;
  if (!comment) return true;
  return !maliciousPatterns.some((p) => p.test(comment));
};

const getFileHeader = async (file, slice = 4) => {
  const buf = await file.arrayBuffer();
  const bytes = new Uint8Array(buf.slice(0, slice));
  return Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");
};

const checkSignature = async (file) => {
  const hex = await getFileHeader(file);
  if (
    (file.type.includes("jpeg") && !hex.startsWith("ffd8ff")) ||
    (file.type === "image/png" && !hex.startsWith("89504e47"))
  ) {
    toast.error("Dosya imza doğrulaması başarısız.");
    return false;
  }
  return true;
};

const checkForMaliciousJS = async (file) => {
  try {
    const text = await file.text();
    if (
      maliciousPatterns.some((r) => r.test(text)) ||
      dangerousRegex.test(text)
    ) {
      toast.error("Dosya içeriğinde şüpheli kod tespit edildi.");
      return false;
    }
    return true;
  } catch {
    // binary, skip
    return true;
  }
};

/**
 * @param {File} file           – Yüklenecek dosya
 * @param {object}  opts        – Opsiyonel ayarlar
 * @param {string[]} opts.allowedTypes – İzinli MIME tipleri
 * @param {number}   opts.maxSize       – Maksimum boyut bayt
 * @returns {Promise<File|null>}        – Geçerliyse File, değilse null
 */
export async function validateFileExceptPdf({ file, allowedTypes = ["image/jpeg", "image/jpg", "image/png"], maxSize = 5 * 1024 * 1024}) {
  // Tür kontrolü
  if (!allowedTypes.includes(file.type)) {
    toast.error("Geçersiz dosya türü. JPG/PNG olmalı.");
    return null;
  }

  // Boyut kontrolü
  if (file.size > maxSize) {
    toast.error("5MB’dan büyük dosya seçilemez.");
    return null;
  }

  // Magic-number kontrolü
  if (!(await checkSignature(file))) {
    return null;
  }

  // JS içeriği kontrolü
  if (!(await checkForMaliciousJS(file))) {
    return null;
  }

  // Metadata kontrolü
  let metadata = {};
  try {
    metadata = await extractImageMetadata(file);
  } catch {
    // hata olsa da devam edilecek
  }
  if (!validateMetadataContent(metadata)) {
    toast.error("Metadata'da zararlı içerik tespit edildi.");
    return null;
  }

  // Tüm kontroller geçti
  return file;
}
